import React from 'react';
import { Messages } from '../../../../codegen/Localize';
import { FormikCheckbox } from '../../../../commonInfra/components/FormikCheckbox';
import { FeatureFlags } from '../../../../ts/FeatureFlags';
import { SettingsSection } from '../../../components/common/SettingsSection';
import { SiteSettingsForSiteAdminProps } from '../ReactSiteSettingsForSiteAdmin';
import { componentRegistryEntry } from '../SettingsComponentRegistryFunctions';

export const WEB_ZONES_FIELD = 'settings.webZoneContentEnabled';

export type WebPageObjectsSectionProps = SiteSettingsForSiteAdminProps<'webZoneContentEnabled'>;

export function WebPageObjectsSection(props: WebPageObjectsSectionProps) {
  return FeatureFlags.webZonesSiteSettingEnabled
    ? (
      <SettingsSection title={Messages.webZoneContentSiteSettingTitle()}
                       testId={'web-zones-enabled-site-setting'}
                       description={Messages.webZoneContentSiteSettingDescription()}>
        <FormikCheckbox name={WEB_ZONES_FIELD}
                        label={Messages.webZoneContentSiteSettingCheckbox()}
                        testId={'web-zones-enabled'}>
        </FormikCheckbox>
      </SettingsSection>
    ) : null;
}

export const WebPageObjectsSectionSpecs = componentRegistryEntry({
  name: 'WebPageObjectsSection',
  component: WebPageObjectsSection
});
